<template>
  <div class="min-h-screen bg-[#FAFAF8] px-6 py-12">
    <div
      class="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8 border border-gray-100 space-y-6"
    >
      <h1 class="text-3xl font-extrabold text-[#0B2447]">
        Politique de Confidentialité
      </h1>

      <section class="space-y-3">
        <h2 class="text-lg font-bold text-orange-600">
          1. Collecte des données
        </h2>
        <p class="text-gray-600 text-sm leading-relaxed">
          GIRAAF PARK s'engage à protéger vos données personnelles. Dans le
          cadre de l'utilisation de Giraaf Workflow, nous recueillons uniquement
          les informations nécessaires au bon fonctionnement de la plateforme
          (nom, adresse e-mail, données de projet).
        </p>
      </section>

      <section class="space-y-3">
        <h2 class="text-lg font-bold text-orange-600">
          2. Utilisation des données
        </h2>
        <p class="text-gray-600 text-sm leading-relaxed">
          Vos données ne sont jamais partagées, vendues ou cédées à des tiers.
          Elles sont uniquement utilisées pour sécuriser votre espace
          utilisateur et gérer vos projets.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfidentialiteView'
}
</script>
